export const SET_CUSTOMER_LISTS = 'SET_CUSTOMER_LISTS'
export const SET_USER_LISTS = 'SET_USER_LISTS'
export const SET_PROJECT_LISTS = 'SET_PROJECT_LISTS'
